import type { Position } from '~/onboarding/types';
import type { Nullable } from '~/utilities/type-guards';
import { isNil } from '~/utilities/type-guards';

export const calculatePosition = (
  position: Position,
  targetRect?: Nullable<DOMRect>,
): { top?: number; left?: number } => {
  if (isNil(targetRect)) {
    return { top: undefined, left: undefined };
  }

  const { bottom = 0, height = 0, left = 0, top = 0, width = 0 } = targetRect;
  const [offsetX, offsetY] = [window.scrollX + left, window.scrollY];

  switch (position) {
    case 'top':
      return { top: top + offsetY, left: width / 2 + offsetX };
    case 'top-right':
      return { top: top + offsetY, left: width + offsetX };
    case 'top-left':
      return { top: top + offsetY, left: offsetX };
    case 'bottom':
      return { top: bottom + offsetY, left: width / 2 + offsetX };
    case 'bottom-left':
      return { top: bottom + offsetY, left: offsetX };
    case 'bottom-right':
      return { top: bottom + offsetY, left: width + offsetX };
    case 'left':
      return { top: top + height / 2 + offsetY, left: offsetX };
    case 'right':
      return { top: top + height / 2 + offsetY, left: width + offsetX };
    default:
      return { top: 0, left: 0 }; // Should never get here
  }
};
